import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
import type { PlacesSearchBarProps } from './PlacesSearchBar';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PlacesExploreSearch" */ './lazyIndex'),
    { name: 'PlacesExploreSearch' }
);

export const PlacesSearchBar: LazyComponent<PlacesSearchBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PlacesSearchBar);
